import type { GuideStep } from '../types';

export const LAYER_NAV_STEPS: GuideStep[] = [
  {
    id: 'layernav-1',
    page: 'index',
    section: 'layer-nav',
    target: 'layer-card',
    fallbackTargets: ['canvas'],
    title: { sv: 'Dyk ned i ett lager', en: 'Dive into a layer' },
    body: {
      sv: 'Dubbelklicka på det highlightade lager-kortet för att kliva in. Canvasen byter till lagrets innehåll och breadcrumbs dyker upp överst.',
      en: 'Double-click the highlighted layer card to dive in. The canvas switches to the layer\'s contents and breadcrumbs appear at the top.',
    },
    advanceOn: { kind: 'layerEntered' },
    showMeHow: {
      steps: [
        { selector: '[data-guide="layer-card"]::eq(0)', action: 'dblclick', label: 'Double-click', hold: 900 },
      ],
      durationMs: 2500,
    },
    waitingHint: {
      sv: 'Dubbelklicka på lager-kortet',
      en: 'Double-click the layer card',
    },
    placement: 'auto',
    order: 1,
  },
  {
    id: 'layernav-2',
    page: 'index',
    section: 'layer-nav',
    target: 'layer-breadcrumb',
    title: { sv: 'Breadcrumbs', en: 'Breadcrumbs' },
    body: {
      sv: 'Breadcrumbs överst på canvasen visar hur djupt du är. Klicka på valfri nivå för att hoppa tillbaka — eller tryck Esc.',
      en: 'Breadcrumbs at the top show how deep you are. Click any level to jump back — or press Esc.',
    },
    placement: 'bottom',
    order: 2,
  },
];
